export default __webpack_public_path__ + "static/media/prize2.b3670731.svg";